import React from 'react'
import YnsIcon from '../../../../icons/YnsIcon'
import { getCareerDevelopmentClassName } from '../../../utils/careerDevelopmentStyles'

const ACTION_BUTTON_BASE =
  'flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border border-intoo-green-medium-800 text-intoo-green-medium-800 hover:bg-intoo-green-medium-800 hover:text-white'

/**
 * Video / text / audio action icons for an available coach card.
 */
function CoachActionButtons({
  coach,
  userCareerDevelopment = false,
  mediaAvailable = true,
  onSelect,
  labels,
}) {
  const showMedia = mediaAvailable && coach.presence?.status === 'audio_video'

  const buttonClass = getCareerDevelopmentClassName(
    userCareerDevelopment,
    ACTION_BUTTON_BASE,
  )

  return (
    <div className="flex items-center justify-center gap-2 @md:justify-start">
      {showMedia && (
        <span
          className={buttonClass}
          title={labels.video}
          onClick={() => onSelect(coach, 'video')}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              onSelect(coach, 'video')
            }
          }}
        >
          <YnsIcon name="video" className="h-6 w-6" />
        </span>
      )}
      <span
        className={buttonClass}
        title={labels.text}
        onClick={() => onSelect(coach, 'text')}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            onSelect(coach, 'text')
          }
        }}
      >
        <YnsIcon name="chat" className="h-6 w-6" />
      </span>
      {showMedia && (
        <span
          className={buttonClass}
          title={labels.audio}
          onClick={() => onSelect(coach, 'audio')}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              onSelect(coach, 'audio')
            }
          }}
        >
          <YnsIcon name="call" className="h-6 w-6" />
        </span>
      )}
    </div>
  )
}

export default CoachActionButtons
